/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('activities/activity-checkbreathing',['require','underscore','jquery','screens/scenario-mapper/scenario','activities/scenario-activity','activities/activity-timer'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  //var Backbone = require('backbone');

  var Scenario = require('screens/scenario-mapper/scenario');
  var ScenarioActivity = require('activities/scenario-activity');
  var ActivityTimer = require('activities/activity-timer');

  //var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var ActivityCheckBreathing = ScenarioActivity.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    attempt: 0,
    maxAttempts: 2,

    handPanel: null,
    counterPanel: null,
    breathingButton: null,

    directionsPanel: null,
    tiltObject: null,

    minHoldCount: 5,
    maxHoldCount: 10,

    timer: null,
    isTimeExceeded: false,
    airwayOpen: false,
    startTime: 0,
    audioTime: 0,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ScenarioActivity.prototype.initialize.apply(this, arguments);

      this.performance = 'good';

      this.attempt = 0;
      this.maxAttempts = 2;

      this.minHoldCount =  5;
      this.maxHoldCount =  10;

      this.timer =  null;
      this.isTimeExceeded =  false;
      this.airwayOpen =  false;
    },

    onRender: function()
    {
      var $openedAirway = Scenario.getVariableValueByName('openedAirway');
      var $swept = ((Scenario.getVariableValueByName('didSweep')) === false) ? false : true;
      this.airwayOpen = $openedAirway && $swept;
      //console.log('airwayopen', this.airwayOpen);

      this.setHeadTilt();
      ScenarioActivity.prototype.onRender.apply(this, arguments);
    },

    begin: function()
    {
      //var self = this;
      ScenarioActivity.prototype.begin.apply(this, arguments);
      //console.warn('show', this.get('#animation-sprite img'));

      //this.playAudio();
      this.playAudio('audio', this.content, this.loadCurrentPhase);
      /*//console.log(this.get('#animation-sprite'));
      this.get('#animation-sprite').sprite({
        'fps': 1,
        'no_of_frames': 2,
        'play_frames': 4,
        //'on_last_frame': self.finish.bind(self)
      });
      //console.log('showing now it should play');
      setTimeout(function() {self.get('#animation-sprite').spStart(true);}, 1000);*/
    },

    onBeforeDestroy: function()
    {
      ScenarioActivity.prototype.onBeforeDestroy.apply(this);
      if (this.timer)
      {
        this.timer.off(ActivityTimer.TIMER);
        this.timer.off(ActivityTimer.TIMER_COMPLETE);
      }
    },

    setupCheckPulse: function()
    {
      this.playAudio('audio', this.currentPhase);

      this.handPanel = this.currentScene.find('[data-mc=panelHolder]');//new DragPanel(this.mc.panelHolder.panel);
      _.each(this.handPanel.find('.airway-hand'), function(hand) {
        $(hand).data().origin = $(hand).position();
      });

      Draggable.create(this.handPanel.find('.airway-hand'), {
        bounds: '[data-role=scenario-activity]',
        onDragEnd: this.onEndDrag,
        onDragEndParams: [this],
        //force3D: false,
        type: 'top, left'
      });

      //var self = this;
      this.dropPanel = this.currentScene.find('[data-mc=drop_items]');
      /*
      this.playAudio('audio', this.currentPhase);

      this.handPanel = this.currentScene.find('[data-mc=panelHolder]');//new DragPanel(this.mc.panelHolder.panel);
      _.each(this.handPanel.find('.airway-hand'), function(hand) {
        $(hand).data().origin = $(hand).position();
      });
      this.handPanel.find('.airway-hand').draggable({
        containment: '[data-role=scenario-activity]',
        cursor: 'move',
        scroll: false,
        //start: $.proxy(this.onStartDrag, this),
        revert: $.proxy(this.onIncorrectDrop, null, this),
        //revert: 'invalid'
      });

      var self = this;
      this.dropPanel = this.currentScene.find('[data-mc=drop_items]');

      _.each(this.dropPanel.find('.activity-drop'), function(dropDiv) {
        var $dropItem = $(dropDiv);
        var $validAccept = (self.currentPhase['universal']) ? '.activity-drag' : '[data-mc=' + $dropItem.attr('data-mc').replace('drop', 'item') + ']';

        $dropItem.droppable({
          accept: $validAccept,
          hoverClass: 'over',
          greedy: true,
          drop: $.proxy(self.onCorrectDrop, self, $dropItem)
        });
      });*/
      //this.handPanel.setup( { onDragStop: this.onCorrectDrop } );
    },

    onEndDrag: function(self)
    {
      var $drag = $(this.target);
      //console.log('end', $drag.data().origin);
      var $cDrop = (self.currentPhase['universal']) ? self.currentScene.find('.activity-drag') : self.currentScene.find('[data-mc=' + $drag.attr('data-mc').replace('item', 'drop') + ']');

      if ($drag.data().origin && Math.abs($drag.data().origin.left - $drag.position().left) <= 150) // still in drop pen
      {
        self.revertDrag($drag);
      }
      else if ($cDrop.length > 0 && Draggable.hitTest($drag, $cDrop, '50%')) // correct
      {
        self.onCorrectDrop.apply(self, [$cDrop, $drag]);
      }
      else // incorrect
      {
        self.onIncorrectDrop(self, $drag);
      }
      //self.onIncorrectDrop.apply($(this.target), self, true);
      //self.onIncorrectDrop($(this.target), true);
    },

    revertDrag: function(drag)
    {
      //console.log('revert', drag, TweenLite);
      //TweenLite.to(drag, 0.5, {transform: 'translate3d(' + drag.data().origin.left + ', ' + drag.data().origin.top + ', 0)'});
      TweenLite.to(drag, 0.5, {left: drag.data().origin.left, top: drag.data().origin.top});
    },

    onCorrectDrop: function($dropItem, $drag)
    {
      ////console.log('on up ', $dropItem, $e, $drag.draggable);

      //$drag.draggable.draggable('disable');
      Draggable.get($drag).disable();
      //$dropItem.data().correct = true;

      if (this.get('.correctDragHolder').length > 0)
      {
        this.get('.correctDragHolder').append($drag);
      }
      if (this.allComplete())
      {
        this.phaseIndex++;
        this.playAudio('audio-feedback-correct', this.phases[this.phaseIndex - 1], this.loadCurrentPhase);
      }

      $drag.offset($dropItem.offset());//($coords, {time: 0.25, transition: 'easeoutquad'}, false);
      return false;
    },

    onIncorrectDrop: function($scope, $drag)
    {
      $scope.scoreValue--;
      $scope.attempt++;
      if ($scope.attempt >= $scope.maxAttempts)
      {
        //$scope.moveHandsToCorrectSpots();

        $scope.phaseIndex++;
        $scope.moveHandsToCorrectSpots($drag);
        $scope.playAudio('audio-feedback-incorrect-final', $scope.phases[$scope.phaseIndex - 1], $scope.loadCurrentPhase);
        return;
      }
      else
      {
        $scope.revertDrag($drag);
        //$drag.returnToOrigin({time: 0.25, transition: 'easeoutquad'});
      }
      $scope.playAudio('audio-feedback-incorrect', $scope.currentPhase);
      return true;
    },

    moveHandsToCorrectSpots: function($activeDrag)
    {
      //this.handPanel.find('.airway-hand').draggable('disable');
      var $sendBack = true;

      for (var $key = 0; $key < this.handPanel.find('.airway-hand').length; $key++)
      {
        var $drag = $(this.handPanel.find('.airway-hand')[$key]);
        Draggable.get($drag).disable();
        var $id = $drag.attr('data-mc').replace('item', 'drop');//NLUtils.getItemNumber($drag.mc);
        var $drop = this.get('[data-mc=drop_items]').find('[data-mc=' + $id + ']');

        if ($drop.length > 0)
        {
          //console.log('compare', $drag, $activeDrag);
          if ($drag.attr('data-mc') === $activeDrag.attr('data-mc'))
            $sendBack = false;
          //var $point = {};//new Point($drop.x, $drop.y);
          //var $coords = {};//NLUtils.localToLocal($point, this.mc, this.handPanel.mc);

          var $adjust = 0;//parseInt(this.handPanel.css('padding')) || 10;
          var $left = $drop.offset().left - this.handPanel.offset().left - $adjust;//.replace('px', '');
          var $top = $drop.offset().top - this.handPanel.offset().top - $adjust;//.replace('px', '');

          if (this.get('.correctDragHolder').length > 0)
            this.get('.correctDragHolder').append($drag);

          $drag.animate({left: $left, top: $top}, {duration: 250});
        }
        else
        {
          this.revertDrag($drag);
        }
      }
      return $sendBack;
    },

    allComplete: function()
    {
      // only 1 correct drop allowed //
      return true;
    },

    loadCurrentPhase: function()
    {
      this.setHeadTilt();
      ScenarioActivity.prototype.loadCurrentPhase.apply(this, arguments);
    },

    // HELPERS //

    setHeadTilt: function()
    {
      var $rotation = Scenario.getVariableValueByName('openAirway_rotation');
      //trace('rotation: ' + $rotation);
      //console.warn('setHeadTilt', $rotation);
      //console.warn(Scenario.getVariableValueByName('openAirway_rotation'));
      var $head = this.get('[data-mc=body] [data-mc=head]');
      if ($head && $rotation && Scenario.getVariableValueByName('openedAirway'))
        $head.rotate(parseInt($rotation));
    },

    setupCheckBreathing: function()
    {
      this.playAudio('audio', this.currentPhase);
      this.currentPhase.hideCounter = (this.currentPhase.hideCounter !== undefined && (this.currentPhase.hideCounter === true || this.currentPhase.hideCounter.toLowerCase() === 'true'));

      this.counterPanel = this.currentScene.find('[data-mc=counterHolder]');
      this.showTime(0);

      //console.log('check breathing setup', this.counterPanel);
      if (this.counterPanel.length > 0)
      {
        this.counterPanel.find('[data-mc=text_tf]').show();
        this.counterPanel.find('[data-mc=disabled_mc]').hide();
        if (_.isEqual(this.currentPhase.hideCounter, true))
        {
          //console.log('hide counter', this.currentPhase.hideCounter, typeof(this.currentPhase.hideCounter), this.currentPhase);
          this.counterPanel.find('[data-mc=text_tf]').hide();
          this.counterPanel.find('[data-mc=disabled_mc]').show();
        }

        if (this.currentPhase.hideCounter && this.currentPhase.hidePace)
        {
          this.counterPanel.hide();//visible = false;
        }
      }

      this.attempt = 0;

      var $mouth = this.currentScene.find('[data-mc=mouth]');
      this.breathingButton = $mouth;//new Button($mouth);
      this.breathingButton.on('touchstart mousedown', $.proxy(this.onMouseDownHandler, this));//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );

      this.setHeadTilt();

      this.showTime(0);
    },

    killSomeTime: function()
    {
      _.delay($.proxy(this.loadCurrentPhase, this), 1000);
    },

    onMouseDownHandler: function($e)
    {
      $e.stopImmediatePropagation();
      $e.preventDefault();
      this.startAction();
      return false;
    },

    onMouseUpHandler: function($e)
    {
      $e.stopImmediatePropagation();
      $e.preventDefault();
      this.stopAction();
      return false;
    },

    startAction: function()
    {
      var d = new Date();
      this.startTime = d.getTime();

      this.breathingButton.off('touchstart mousedown');//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );
      this.breathingButton.on('touchend mouseup', $.proxy(this.onMouseUpHandler, this));//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );
      this.breathingButton.on('mouseout', $.proxy(this.onMouseUpHandler, this));//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );
      this.startTimer();
      this.playAudio('audio-breaths', this.currentPhase);
    },

    audioStarted: function()
    {
      var d = new Date();
      this.audioTime = d.getTime();
    },

    stopAction: function()
    {
      this.stopMedia();
      this.breathingButton.on('touchstart mousedown', $.proxy(this.onMouseDownHandler, this));//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );
      this.breathingButton.off('touchend mouseup');//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );
      this.breathingButton.off('mouseout');//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );
      if (this.isTimeExceeded)
        return;

      this.stopTimer();

      if (!this.timer)
        return;

      if (this.timer.currentCount < this.minHoldCount)
        this.incorrectAction('-low');
      else if (this.timer.currentCount > this.maxHoldCount)
        this.incorrectAction('-high');
      else
        this.correctAction();
    },

    correctAction: function()
    {
      this.disableBreathButton();
      this.playAudio('audio-feedback-correct', this.currentPhase, $.proxy(this.audioCompleteCallback, this));
    },

    incorrectAction: function($range)
    {
      $range = ($range === undefined) ? '' : $range;

      this.showTime(this.timer.currentCount);

      this.showTime(0);

      var $audio = _.findWhere(this.currentPhase.ContentAudio, {'id': 'audio-feedback-incorrect' + $range});//this.currentPhase.getByID('audio-feedback-incorrect' + $range);

      if (!$audio)
        $range = '';

      this.playAudio('audio-feedback-incorrect' + $range, this.currentPhase);
    },

    disableBreathButton: function()
    {
      this.breathingButton.addClass('disabled');
      this.breathingButton.off('touchstart mousedown');
      this.breathingButton.off('touchend mouseup');
      this.breathingButton.off('mouseout');//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );
    },

    audioCompleteCallback: function()
    {
      this.finish();
    },

    startTimer: function($delay)
    {
      $delay = ($delay === undefined) ? 1000 : $delay;

      this.isTimeExceeded = false;

      if (!this.timer)
      {
        this.timer = new ActivityTimer($delay, this.maxHoldCount + 1);
        this.timer.on(ActivityTimer.TIMER_COMPLETE, $.proxy(this.timerCompleteHandler, this));
        this.timer.on(ActivityTimer.TIMER, $.proxy(this.timerTickHandler, this));
      }

      this.timer.reset();
      this.timer.start();
    },

    stopTimer: function()
    {
      if (this.timer)
        this.timer.stop();
    },

    timerTickHandler: function(e)
    {
      this.showTime(this.timer.currentCount);
    },

    timerCompleteHandler: function(e)
    {
      this.timeExceeded();
    },

    timeExceeded: function()
    {
      this.isTimeExceeded = true;
      this.stopAction();
      this.performance = ScenarioActivity.PERFORMANCE_POOR;
      this.stopTimer();
      this.incorrectAction('-high');
    },

    showTime: function($sec)
    {
      $sec = ($sec === undefined) ? 0 : $sec;
      if (!this.counterPanel)
        return;

      if ($sec < 10)
        this.counterPanel.find('[data-mc=text_tf]').html(':0' + $sec.toString());
      else
        this.counterPanel.find('[data-mc=text_tf]').html(':' + $sec.toString());
    }

  /*****************************************************************************************************************///}

  });

  return ActivityCheckBreathing;

});

